import React from 'react';
import styled from 'styled-components';
import { Button } from '../../styles/common/Button.styled';
const State = styled.div`
  display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 10px;
  min-height: 160px; padding: 32px 20px; text-align: center; white-space: normal;
  color: ${({ theme }) => theme.color.text_color_300}; font-size: 13px;
  strong { color: ${({ theme }) => theme.color.text_color_100}; font-weight: 500; }
`;
export default function PageState({ status, title, description, onRetry, children }: {
  status: 'loading' | 'empty' | 'error'; title?: string; description?: string; onRetry?: () => void; children?: React.ReactNode;
}) {
  return <State role={status === 'error' ? 'alert' : 'status'} aria-live="polite" aria-busy={status === 'loading'}>
    <strong>{title || (status === 'loading' ? '데이터를 불러오는 중입니다.' : status === 'error' ? '데이터를 불러오지 못했습니다.' : '표시할 데이터가 없습니다.')}</strong>
    {description && <span>{description}</span>}{status === 'error' && onRetry && <Button $variant="secondary" onClick={onRetry}>다시 시도</Button>}{children}
  </State>;
}
